/** Page build caoursel - video */
$('.wom-carousel__inner').each(function () {
    var $carousel = $(this),
        slideCount = $carousel.find('.slide').length;

    $carousel.owlCarousel({
        items: 1,
        autoHeight: true,
        loop: slideCount > 1 ? true : false,
        nav: slideCount > 1 ? true : false,
        navText: [],
        margin: 10,
        mouseDrag: slideCount > 1 ? true : false,
        touchDrag: slideCount > 1 ? true : false,
        pullDrag: slideCount > 1 ? true : false,
        navContainer: $(this).parents('.container').find('.custom-nav .nav')
    });
});
